import { jsx } from "react/jsx-runtime";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { ButtonBase, IconButton, inputBaseClasses, styled, TextField } from "@mui/material";
import { NO_COLOR } from "../../constants.js";
import { useColorPicker } from "../../hooks/useColorPicker.js";
import { Chip } from "../Swatch/components/Chip.js";
import { NoColorChip } from "../Swatch/components/NoColorChip.js";
import { NoColorIcon } from "../Swatch/components/NoColorIcon.js";
const chipSize = 24;
function SelectTrigger(props) {
  const { onClick, color, open, colorLabel, disabled, sx } = props;
  const { localeText } = useColorPicker();
  const colorText = color === NO_COLOR ? localeText.noColorLabel : color;
  const _textFieldValue = typeof colorLabel === "function" ? colorLabel(color) : colorLabel ?? colorText;
  return /* @__PURE__ */ jsx(BaseButton, { disabled, disableRipple: true, onClick, sx, children: /* @__PURE__ */ jsx(
    TextField,
    {
      "data-testid": "SelectTrigger--TextField",
      disabled,
      focused: open,
      fullWidth: true,
      label: localeText.triggerSelectLabel,
      slotProps: {
        input: {
          endAdornment: /* @__PURE__ */ jsx(EndAdornment, { onClick, open }),
          readOnly: true,
          startAdornment: /* @__PURE__ */ jsx(StartAdornment, { color })
        }
      },
      sx: {
        [`& .${inputBaseClasses.input}`]: {
          cursor: "pointer"
        }
      },
      value: colorText
    }
  ) });
}
function EndAdornment(props) {
  const { open, onClick } = props;
  return /* @__PURE__ */ jsx(IconButton, { component: "span", onClick, children: /* @__PURE__ */ jsx(
    ArrowDropDown,
    {
      color: "action",
      style: {
        rotate: `${open ? "-180deg" : "0deg"}`,
        transition: "rotate 0.2s ease"
      }
    }
  ) });
}
function StartAdornment(props) {
  const { color } = props;
  if (color === NO_COLOR) {
    return /* @__PURE__ */ jsx(
      NoColorChip,
      {
        bgcolor: color,
        component: "span",
        "data-testid": "TidalColorPickerPopoverSwatch",
        size: chipSize,
        sx: { mr: 1 },
        children: /* @__PURE__ */ jsx(NoColorIcon, {})
      }
    );
  }
  return /* @__PURE__ */ jsx(Chip, { bgcolor: color, component: "span", "data-testid": "TidalColorPickerPopoverSwatch", size: chipSize, sx: { mr: 1 } });
}
const BaseButton = styled(ButtonBase, {
  slot: "SelectTriggerButtonBase"
})(() => {
  return {
    width: "100%"
  };
});
export {
  BaseButton,
  SelectTrigger
};
//# sourceMappingURL=SelectTrigger.js.map
